export const redBox = {
  borderStyle: 'solid',
  borderColor: 'red',
  borderWidth: 1,
};

export const greenBox = {
  borderStyle: 'solid',
  borderColor: 'green',
  borderWidth: 1,
};

export const blueBox = {
  borderStyle: 'solid',
  borderColor: 'blue',
  borderWidth: 1,
};

export const orangeBox = {
  borderStyle: 'solid',
  borderColor: 'orange',
  borderWidth: 1,
};

export const yellowBox = {
  borderStyle: 'solid',
  borderColor: 'yellow',
  borderWidth: 1,
};
